import { Suspense, useState } from "react";
import { BrowserRouter as Router, Routes } from "react-router-dom";

import { ProjectRouteSync } from "./components/ProjectRouting/ProjectRouting";
import { PRODUCTION_PREFIX } from "./config";
import { routes } from "./config/routes";
import { ProjectProvider } from "./contexts/ProjectContext";
import { SiteDataProvider } from "./contexts/SiteDataContext";
import type { SiteData } from "./contexts/SiteDataContextTypes";

function App() {
  const currentPath = window.location.pathname;

  const basename = currentPath.startsWith(PRODUCTION_PREFIX)
    ? PRODUCTION_PREFIX
    : "";

  const [siteData, setSiteData] = useState<SiteData>({
    isOpenMobileMenuModal: false,
  });

  return (
    <SiteDataProvider siteData={siteData} setSiteData={setSiteData}>
      <ProjectProvider>
        <Router basename={basename}>
          <ProjectRouteSync />
          <Suspense fallback={null}>
            <Routes>{routes}</Routes>
          </Suspense>
        </Router>
      </ProjectProvider>
    </SiteDataProvider>
  );
}

export default App;
